module.exports = __webpack_public_path__ + "img/brazil.d60aaac.webp";